var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{attrs:{"href":_vm.props.row.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.props.row.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }